var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFrameHomepageSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 758,
    height: 170,
    viewBox: "0 0 758 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.26095 14.2147L3.18283 16.4185L3.13645 24.2028L8.31955 21.9441L8.26095 14.2147Z",
    fill: "#7AE7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24435 25.1251L3.1661 27.3381L3.11993 35.1134L8.30304 32.8638L8.24435 25.1251Z",
    fill: "#7AE7FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.22763 36.0448L3.14955 38.2486L3.10332 46.0331L8.28637 43.7743L8.22763 36.0448Z",
    fill: "#7AE7FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.21212 46.9553L3.13387 49.1683L3.0877 56.9434L8.27081 54.6939L8.21212 46.9553Z",
    fill: "#7AE7FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M732.224 2.51454L33.8267 2.42512L15.0641 12.5218L14.7922 55.719L4.14038 61.4446L3.75632 112.429L10.6782 116.176L10.4428 157.581L30.914 168.662L737.755 168.752L751.308 161.467L751.45 137.798L747.032 135.407L747.378 88.353L750.894 86.4634L751.348 13.026L732.224 2.51454Z",
    fill: "#171717"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M752.037 92.0869L757.089 94.2601L757.043 101.932L751.907 99.7134L752.037 92.0869Z",
    fill: "#7AE7FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M752.02 102.839L757.072 105.021L757.027 112.693L751.891 110.466L752.02 102.839Z",
    fill: "#7AE7FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M752.004 113.601L757.056 115.783L757.011 123.445L751.875 121.227L752.004 113.601Z",
    fill: "#7AE7FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M751.988 124.362L757.041 126.535L756.995 134.206L751.859 131.979L751.988 124.362Z",
    fill: "#7AE7FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0082 135.113L18.0575 137.403L18.009 145.485L12.8765 143.138L13.0082 135.113Z",
    fill: "#7AE7FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.991 146.441L18.0402 148.74L17.992 156.813L12.8594 154.476L12.991 146.441Z",
    fill: "#7AE7FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M732.394 2.19593L31.8817 2.00784L13.1579 12.0843L13.0155 55.8128L2.38573 61.527L2.17369 110.657L9.10382 114.399L8.97614 157.193L29.4716 168.257L738.424 168.448L751.949 161.177L752.02 136.943L747.597 134.555L747.8 88.4935L751.308 86.6077L751.541 12.6917L732.394 2.19593Z",
    stroke: "#7AE7FF",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameHomepageSmall);
export default __webpack_public_path__ + "static/media/FrameHomepageSmall.028cb45ce426c1c71d48b71effa5d5d7.svg";
export { ForwardRef as ReactComponent };